import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.66667 11.333H3C2.07953 11.333 1.33334 10.5868 1.33334 9.66634V2.99967C1.33334 2.0792 2.07953 1.33301 3 1.33301H9.66667C10.5871 1.33301 11.3333 2.0792 11.3333 2.99967V4.66634M6.33334 14.6663H13C13.9205 14.6663 14.6667 13.9201 14.6667 12.9997V6.33301C14.6667 5.41253 13.9205 4.66634 13 4.66634H6.33334C5.41286 4.66634 4.66667 5.41253 4.66667 6.33301V12.9997C4.66667 13.9201 5.41286 14.6663 6.33334 14.6663Z" />
  </svg>
);
